// This code has been partially generated by an AI.
import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import * as de from '@angular/common/locales/de';
import { ApplicationConfig, enableProdMode, ErrorHandler, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { routes } from '@app/app.routes';
import { APIInterceptor } from '@app/core/services/interceptors/api-interceptor';
import { GlobalErrorHandler } from '@app/core/services/interceptors/global-error-handler';
import { environment } from '@environments/environment';
import { provideNgIconsConfig } from '@ng-icons/core';
import {
  AutoRefreshTokenService,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  includeBearerTokenInterceptor,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { apiUrlCondition } from './keycloak.config';

registerLocaleData(de.default);

if (environment.production) {
  enableProdMode();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    { provide: HTTP_INTERCEPTORS, useClass: APIInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'short' } },
    provideKeycloak({
      config: { url: environment['keycloakUrl'] ?? `${globalThis.location.origin}/auth`, realm: 'if', clientId: 'skilltree-frontend' },
      // the realm's browser flow redirects straight to Entra ID; employee registration runs in employeeRegisteredGuard
      initOptions: { onLoad: 'login-required' },
      // refresh token expired or user inactive: log in again instead of letting every API call fail
      features: [withAutoRefreshToken({ onInactivityTimeout: 'login' })],
      providers: [
        AutoRefreshTokenService,
        UserActivityService,
        { provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, useFactory: apiUrlCondition },
      ],
    }),
    provideHttpClient(withXhr(), withInterceptorsFromDi(), withInterceptors([includeBearerTokenInterceptor])),
    provideNgIconsConfig({ size: '1.25rem', strokeWidth: '2' }),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
  ],
};
